/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface Size
 */
export interface Size {
    /**
     * 
     * @type {number}
     * @memberof Size
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof Size
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof Size
     */
    $type?: SizeTypeEnum;
}


/**
 * @export
 */
export const SizeTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoArrayDetectorLayoutDtoSizePtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.ArrayDetectorLayoutDto+Size, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type SizeTypeEnum = typeof SizeTypeEnum[keyof typeof SizeTypeEnum];



/**
 * Check if a given object implements the Size interface.
 */
export function instanceOfSize(value?: unknown): value is Size {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SizeTypeEnum)[0];
}

export function SizeFromJSON(json: any): Size {
    return SizeFromJSONTyped(json, false);
}

export function SizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Size {
    if (json == null) {
        return json;
    }
    return {
        
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function SizeToJSON(value?: Size | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'width': value['width'],
        'height': value['height'],
        '$type': value['$type'],
    });
}

